import useLanguage from "hooks/language";
import { FollowUpType } from "models/appointment";
import { RadioCard } from "../../../../../components";
import styles from "./service-select.module.css";

type ServiceSelectProps = {
    selectedFollowUp?: FollowUpType;
    onSelectFollowUp: (selectedFollowUp: FollowUpType) => void;
    disabled?: boolean;
};

export default function ServiceSelect({
    selectedFollowUp,
    onSelectFollowUp,
    disabled = false,
}: ServiceSelectProps): JSX.Element {
    const { translations } = useLanguage();
    const t = translations.upfrontPaymentSection.public;

    return (
        <fieldset
            className={`${styles.serviceSelect__container} ${styles["serviceSelect__container--card-group"]}`}
        >
            <RadioCard
                checked={selectedFollowUp === FollowUpType.Regular}
                name="service"
                value={FollowUpType.Regular}
                onSelect={onSelectFollowUp}
                radioPosition="top"
                disabled={disabled}
            >
                <strong className={styles.serviceCard__title}>
                    {t.regularServiceLabel}
                </strong>
                <p
                    className={styles.serviceCard__content}
                    dangerouslySetInnerHTML={{
                        __html: t.regularServiceDescription,
                    }}
                ></p>
            </RadioCard>
            <RadioCard
                checked={selectedFollowUp === FollowUpType.Express}
                name="service"
                value={FollowUpType.Express}
                onSelect={onSelectFollowUp}
                radioPosition="top"
                disabled={disabled}
            >
                <strong className={styles.serviceCard__title}>
                    {t.expressServiceLabel}
                </strong>
                <p
                    className={styles.serviceCard__content}
                    dangerouslySetInnerHTML={{
                        __html: t.expressServiceDescription,
                    }}
                ></p>
            </RadioCard>
        </fieldset>
    );
}
